import React, { Component, Fragment } from 'react';
import ReturnPageHeader from "pages/returnCheckout/ReturnPageHeader" 
import { Table } from 'elemental-react16'
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea} from "semantic-ui-react"
import shop from "shop/shop"
import ProductTable from "components/Product/ProductTableReturnReadOnly"
import CartTotal from "components/Cart/CartTotal"
import _ from "lodash"
import { Link } from "react-router-dom"
import Spinner                              from "components/Spinner/Spinner"
import Responsive from "react-responsive"

class ReturnPageConfirmation extends Component {

    state = {
        cleanUP: false
    }

    componentDidMount() {
        shop.cart.hooks.changed.add( this.updateCart )
        shop.cart.hydrate()
        shop.cart.update()
        if(!shop.delivery[0]){
          //console.log("shop.delivery is empty")
          this.props.history.push("/return")
        }
        if(!shop.delivery){
            //console.log("shop.delivery is empty")
            this.props.history.push("/return")
        }
    }

    handleChange = ( { product } ) => {
    let cleanUpValue = true
    product.cleanUpValue = cleanUpValue
    //console.log("HANDLE CHANGE PRODUCT: ", product)
    shop.cart.add( product )
    }
    
    updateCart = () => {
    let products = getProducts()
    products = getProducts()
    //console.log("RETURN UPDATECART: ", products)
    this.setState( { products } )
    this.forceUpdate()
    }
    
    componentWillUnmount() {
    this.setState({productsTemp: shop.cart.products})
    shop.cart.hooks.changed.remove( this.updateCart )
    }

    handleOrderTypeChange = async ( ) => {
        await shop.cart.setExtra( "ts-ordertype", "inventory" )
        await shop.cart.setExtra( "contact", shop.delivery[0].contact.contact )
        await shop.cart.setExtra( "comment", shop.delivery[0].contact.comment )
        await shop.cart.setExtra( "email", shop.delivery[0].contact.email )
        await shop.cart.setExtra( "phone", shop.delivery[0].contact.phone )
    }

    handleSubmit = async () => {
        //console.log("RETURN HANDLE SUBMIT: ", shop.cart)
        await this.handleOrderTypeChange()
        this.setState({cleanUP: true})
        const delay = ms => new Promise(
            resolve => setTimeout(resolve, ms)
          );
        shop.toast( translate( "Restantenerfassung erfolgt!" ) )

        let rows = _.map( getProducts(), ( product, index ) => {
            //console.log("RETURN HANDLESUBMIT: ", product._count)
            if(product._count == 1){
                //console.log("RETURN FAKE PRODUCT1: ", product)
                shop.cart.remove( product )
                
            }
          } )
          await delay(500);
          let rows2 = _.map( getProducts(), ( product, index ) => {
            //console.log("RETURN HANDLESUBMIT: ", product._count)
            if(product._count == 1){
                //console.log("RETURN FAKE PRODUCT2: ", product)
                shop.cart.remove( product )
                
            }
          } )
          await delay(500);
          let rows3 = _.map( getProducts(), ( product, index ) => {
            //console.log("RETURN HANDLESUBMIT: ", product._count)
            if(product._count == 1){
                //console.log("RETURN FAKE PRODUCT3: ", product)
                shop.cart.remove( product )
                
            }
          } )
          await delay(500);
          let rows4 = _.map( getProducts(), ( product, index ) => {
            //console.log("RETURN HANDLESUBMIT: ", product._count)
            if(product._count == 1){
                //console.log("RETURN FAKE PRODUCT4: ", product)
                shop.cart.remove( product )
                
            }
          } )
          await delay(500);
        let rows5 = _.map( getProducts(), ( product, index ) => {
        //console.log("RETURN HANDLESUBMIT: ", product._count)
        if(product._count == 1){
            //console.log("RETURN FAKE PRODUCT5: ", product)
            shop.cart.remove( product )
            
        }
        } )
        await delay(500);
        let rows6 = _.map( getProducts(), ( product, index ) => {
            //console.log("RETURN HANDLESUBMIT: ", product._count)
            if(product._count == 1){
                //console.log("RETURN FAKE PRODUCT6: ", product)
                shop.cart.remove( product )
                
            }
            } )
        await delay(500);
        let rows7 = _.map( getProducts(), ( product, index ) => {
            //console.log("RETURN HANDLESUBMIT: ", product._count)
            if(product._count == 1){
                //console.log("RETURN FAKE PRODUCT7: ", product)
                shop.cart.remove( product )
                
            }
            } )
        await delay(500);
          //console.log("FINAL CART CONFIRMATION1: ", shop.cart)
        let rows8 = _.map( getProducts(), ( product, index ) => {
        //console.log("RETURN HANDLESUBMIT: ", product._count)
        if(product._count == 1){
            //console.log("RETURN FAKE PRODUCT8: ", product)
            shop.cart.remove( product )
        }
        else{
            this.handleChange( { product } )
        }
        } )
        await delay(1000);
        //console.log("RETURN CURRENT CART: ", shop.cart)
        shop.cart.hooks.changed.add( this.updateCart )
        shop.cart.hydrate()
        shop.cart.update()
        //console.log("FINAL CART CONFIRMATION2: ", shop.cart)
        

		this.props.history.push( "/return/success" )
	}

    render() {
        if(!shop.delivery){
            //console.log("shop.delivery is empty")
            this.props.history.push("/return")
            document.location.reload()
            return null
        }
        if(this.state.cleanUP == true){
            return (
                <div className="pa4 pt7 tc">
                    <Spinner size="md" type="inverted"/>
                </div>
            )
        }
        return (
            <Fragment>
                <Responsive minWidth={790}>
                <div>
                <Table>
                <colgroup>
                    <col width="10%" />
                    <col width="12%" />
                    <col width="3%" />
                    <col width="55%" />
                </colgroup>
                <tbody>
                    <tr>
                        <td>
                            &nbsp;
                        </td>
                        <td className="pr4  pl4 v-top ReturnPageAlignment" >
                            <ReturnPageHeader className="pt7" activeStep={2} />
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td className="pr4  pl4 v-top ReturnPageAlignment" >
                        <h1 style={{color:"#265a88", fontSize:40}}  className="pt5 tl"><b>Restanten bestätigen</b></h1>
                            <Message style={{width: "80%"}}>
                                <div>Bitte überprüfen Sie Ihre Eingaben auf Vollständigkeit.</div>
                            </Message>
                            {console.log("SHOP DELIVERY: ", shop.delivery)}
                            <Table style={{width: "80%"}}>
                                <thead>
                                    <tr>
                                        <th>
                                        <p className="pt3"><h2 style={{color:"#265a88", fontSize:22}}>Erreichbarkeit</h2></p>
                                        </th>
                                        <th>
                                            &nbsp;
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div >
                                                <p className="fw7">Ansprechpartner</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p>{shop.delivery[0].contact.contact}</p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div >
                                                <p className="fw7">Extern</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {shop.delivery[0].contact.external && shop.delivery[0].contact.external.toString() == "true" && <p>Ja</p>}
                                                {shop.delivery[0].contact.external && shop.delivery[0].contact.external.toString() == "false" && <p>Nein</p>}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div>
                                                <p className="fw7">Telefon</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p>{shop.delivery[0].contact.phone}</p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div>
                                                <p className="fw7">E-Mail</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p>{shop.delivery[0].contact.email}</p>
                                            </div>
                                        </td>
                                    </tr>
                                    {/*<tr>
                                        <td>
                                            <div >
                                                <p className="fw7">Bemerkung</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p>{shop.delivery[0].contact.comment}</p>
                                            </div>
                                        </td>
                                    </tr>*/}
                                </tbody>
                            </Table>
                            <br/>
                            <Table style={{width: "80%"}}>
                                <thead>
                                    <tr>
                                        <th>
                                        <p className="pt3"><h2 style={{color:"#265a88", fontSize:22}}>Restanten</h2></p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <ProductTable cart={shop.cart} onChange={this.handleChange} products={getProducts()}/>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </td>
                    </tr>
                    <tr>
                    <td>
                            &nbsp;
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td className="tr divAlignRight">
                        <strong style={{color:"#265a88", fontSize:16}} >Restantenmenge: </strong>&nbsp;<CartTotal sum={shop.cart.sum} size={shop.cart.size}/>
                        </td>
                    </tr>
                    <tr>
                    <td>
                            &nbsp;
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td>
                        <Message className="ui negative message" style={{width: "80%"}}>
                            <div>{translate("LINDT & SPRÜNGLI vergütet Ihnen 25% des Netto-Einkaufspreises (Brutto-EK ./. aller Zentralkonditionen).")}</div>
                        </Message>
                        </td>
                    </tr>
                    <tr>
                    <td>
                            &nbsp;
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td>
                            <div style={{paddingTop: "50px",width: "80%"}} className="">
                            <Link to={{
                                pathname: `/return/contactPerson`,
                                search  : this.props.location.search
                            }}>
                                <Button
                                primary >
                                {translate( "Zurück" )}
                                <i className="icon-angle-right"/>
                                </Button>
                            </Link>
                                <Button
                                    className="fr"
                                    disabled={false}
                                    primary
                                    onClick={this.handleSubmit}
                                    >{translate( "Restanten bestätigen" )}</Button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </Table>
            </div>
                </Responsive>
                <Responsive maxWidth={789}>
                <table>
                <colgroup>
                    <col width="90%" />
                </colgroup>
                <tbody>
                    <tr className="bb b--black-10"> 
                        <td>
                        <div className="headerInline"><Button style={{backgroundColor: "#ffffff", maxWidth:"55px"}} 
                            onClick={() => (this.state.navHeader ? this.setState({navHeader : false}) : this.setState({navHeader : true}
                            ))}>
                                <Icon className="big bars tc" ></Icon>
                            </Button><span className="pt3 tc fw7 f2">Restanten</span></div>
                        {this.state.navHeader && <ReturnPageHeader className="v-top" activeStep={2} />}
                        </td>
                        </tr>
                        <tr>
                        <td className="tc pr2  pl2 v-top ReturnPageAlignment" >
                            <h1 style={{color:"#265a88", fontSize:36}}  className="tc"><b>Restanten bestätigen</b></h1>
                            <Message className="tc">
                                <div>{translate( "Bitte überprüfen Sie Ihre Eingaben auf Vollständigkeit.")}</div>
                            </Message>
                            <p className="pt3"><h2 style={{color:"#265a88", fontSize:22}}>Erreichbarkeit</h2></p>
                            <table className="pr3 pl3">
                            <colgroup>
                                <col width="25%" />
                                <col width="75%" />
                            </colgroup>
                                <tbody>
                                    <tr className="bb b--black-20">
                                        <td>
                                            <div >
                                                <p className="fw7">Ansprechpartner:</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p className="tr">{shop.delivery[0].contact.contact}</p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="bb b--black-20">
                                        <td>
                                            <div >
                                                <p className="fw7">Extern:</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                            {shop.delivery[0].contact.external && shop.delivery[0].contact.external.toString() == "true" && <p className="tr">Ja</p>}
                                            {shop.delivery[0].contact.external && shop.delivery[0].contact.external.toString() == "false" && <p className="tr">Nein</p>}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="bb b--black-20">
                                        <td>
                                            <div>
                                                <p className="fw7">Telefon:</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p className="tr">{shop.delivery[0].contact.phone}</p>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="bb b--black-20">
                                        <td>
                                            <div>
                                                <p className="fw7">E-Mail:</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p className="tr">{shop.delivery[0].contact.email}</p>
                                            </div>
                                        </td>
                                    </tr>
                                    {/*<tr className="bb b--black-20">
                                        <td>
                                            <div >
                                                <p className="fw7">Bemerkung:</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <p className="tr">{shop.delivery[0].contact.comment}</p>
                                            </div>
                                        </td>
                                    </tr>*/}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr className="">
                        <td>
                            <p className="pt3 tc"><h2 style={{color:"#265a88", fontSize:22}}>Restanten</h2></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <ProductTable cart={shop.cart} onChange={this.handleChange} products={getProducts()}/>
                        </td>
                    </tr>
                    <tr>
                    <td className="tr">
                    <div className="tr pt2 pr3">
                            <strong style={{color:"#265a88", fontSize:18}} >Restantenmenge: </strong>&nbsp;<CartTotal sum={shop.cart.sum} size={shop.cart.size}/>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="tl">
                            <Link to={{
                                pathname: `/return/contactPerson`,
                                search  : this.props.location.search
                            }}>
                                <Button
                                primary >
                                {translate( "Zurück" )}
                                <i className="icon-angle-right"/>
                                </Button>
                            </Link>
                                <Button
                                    className="fr"
                                    disabled={false}
                                    primary
                                    onClick={this.handleSubmit}
                                    >{translate( "Restanten bestätigen" )}</Button>
                            </div>
                        </td>
                    </tr>
                        </tbody>
                        </table>
                </Responsive>
            </Fragment>
        );
    }
}

const getProducts = () => shop.cart.map( ( product ) => product)

export default ReturnPageConfirmation;


// WEBPACK FOOTER //
// ./src/theme/braunsheitmann/pages/returnCheckout/ReturnPageConfirmation.js